import LotsItemIcons from './lots-item-icons';
export default LotsItemIcons;